import { render, staticRenderFns } from "./hhjcTable.vue?vue&type=template&id=2843fbd6&"
import script from "./hhjcTable.vue?vue&type=script&lang=js&"
export * from "./hhjcTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports